"use client";

import { forwardRef, type ButtonHTMLAttributes } from "react";
import { useInjectStyles } from "../utils/useInjectStyles";

/**
 * danger 自 2026-09-02 起為 ghost 樣式（紅字、hover 才浮現淺紅底）——清單頁一次
 * 出現 20 個實心紅塊會造成「危險疲勞」，真正需要警覺時反而失效。
 * danger-solid 是保留下來的實心紅底，僅用於確認對話框裡的最終確認按鈕。
 */
export type ButtonVariant =
  | "primary"
  | "secondary"
  | "danger"
  | "danger-solid"
  | "ghost"
  /** 無框、主色文字、hover 淺底。清單頁動作欄的「編輯」用它，與 ghost 的「刪除」成對。 */
  | "link";

export interface ButtonProps extends ButtonHTMLAttributes<HTMLButtonElement> {
  variant?: ButtonVariant;
  size?: "md" | "sm";
}

/**
 * forwardRef 是必要的，不是為了泛用性：確認對話框要把預設焦點放在「取消」鈕上
 * （破壞性操作刻意不讓 Enter 落在確認鈕），拿不到 DOM 節點就做不到。
 */
export const Button = forwardRef<HTMLButtonElement, ButtonProps>(function Button(
  { variant = "secondary", size = "md", className, ...rest },
  ref,
) {
  useInjectStyles();
  const cls = [
    "cui-reset",
    "cui-btn",
    `cui-btn-${variant}`,
    size === "sm" ? "cui-btn-sm" : "",
    className ?? "",
  ]
    .filter(Boolean)
    .join(" ");
  return <button ref={ref} type="button" className={cls} {...rest} />;
});
